import * as Yup from 'yup';

const addressValidationSchema = Yup.object().shape({
  city_id: Yup.string().required('نام شهر الزامی است!'),
  // entry_city: Yup.string().required('نام شهر الزامی است!'),
  entry_firstname: Yup.string().required('نام کوچک الزامی است!'),
  entry_lastname: Yup.string().required('نام خانوادگی الزامی است!'),
  entry_postcode: Yup.string()
    .required('کد پستی الزامی است!')
    .matches(/^[0-9\u06F0-\u06F9]+$/, 'کد پستی باید فقط شامل اعداد باشد!')
    .length(10, 'کد پستی باید ۱۰ رقم باشد!'),
  // entry_state: Yup.string().required('نام استان الزامی است!'),
  entry_street_address: Yup.string().required('آدرس خیابان الزامی است!').min(5, 'آدرس خیابان باید حداقل ۵ کاراکتر باشد!'),
  label: Yup.string().required('برچسب الزامی است!'),
  pelak: Yup.string()
    .matches(/^[0-9\u06F0-\u06F9]+$/, 'پلاک باید فقط شامل اعداد باشد!')
    .required('پلاک الزامی است!'),
  state_id: Yup.string().required('نام استان الزامی است!'),
  vahed: Yup.string()
    .matches(/^[0-9\u06F0-\u06F9]*$/, 'واحد باید فقط شامل اعداد باشد!')
    .required('واحد الزامی است!'),
});

export default addressValidationSchema;
